module.exports = __webpack_public_path__ + "img/landordpix.cf16bd47.png";